// require('ta-semantic-ui/semantic/dist/components/icon.css');

require('./svgMap.styl');

import React from 'react';
// import Tooltip from '../tooltip/Tooltip';
// import ZhCircleMap from '../zhCircleMap/zhCircleMap';

// import {timeParse,timeFormat} from 'd3-time-format';
import {scaleLinear, scaleOrdinal, scaleTime} from 'd3-scale';
// import {line, curveCatmullRom} from 'd3-shape';
import {extent, max, mean, median} from 'd3-array';
import {select as d3select} from 'd3-selection';
// import {axisBottom as d3axisBottom, axisLeft as d3axisLeft} from 'd3-axis';
import {formatDefaultLocale,format} from 'd3-format';
// import {interpolate} from 'd3-interpolate';
import {keys, nest} from 'd3-collection';
import ReactSVG from 'react-svg';

const localeDefinition = require('json!de-ch-locale');

/************************************************************************/

class SVGMap extends React.Component {

  colorScale = scaleLinear();

  constructor(props) {
    super(props);

    const dataByYear = nest()
      .key(function (d) {
        return d.Jahr
      })
      .key(function (d) {
        return d.QuarSort
      })
      .entries(this.props.mapData);

    const actualData = [];

    for(var i=0; i<dataByYear.length; i++) {
      if(dataByYear[i].key == this.props.mapDataYear.toString()) {
        actualData.push(dataByYear[i])
      }
    }

    let minMaxAmount = [];

    for(let x=0; x<actualData[0]['values'].length; x++) {
      minMaxAmount.push(actualData[0]['values'][x]['values'][0]['QuadratmeterPreis']);
    }

    let dataExtent = extent(minMaxAmount);
    // console.log(dataExtent);

    this.colorScale = scaleLinear().domain(dataExtent).range(['#EFEFEF','#E23C4E'])

    this.state= {
      width: this.props.width,
      height: this.props.height,
      showTooltip: false,
      actualMapData: actualData,
      dataMatched: false
    }

    this.mouseEntersMapPart= this.mouseEntersMapPart.bind(this);
    this.mouseLeavesMapPart= this.mouseLeavesMapPart.bind(this);

  }

  componentDidMount() {

    let svgElements = document.getElementsByTagName('path');

  }

  mouseEntersMapPart(e, svg) {
    let title = (e.getAttribute('id'));

    //console.log(title);

    this.setState({
      dataMatched: false,
    })

    // DESKTOP AND TOUCH DEVICE SWITCH
    if (('ontouchstart' in window) ||
      (navigator.maxTouchPoints > 0) ||
      (navigator.msMaxTouchPoints > 0)) {
      this.setState({
        tooltipY: 115,
        tooltipFontSize: '1.2em'
      })
    } else {
      this.setState({
        tooltipY: 65,
        tooltipFontSize: '1.2em'
      })
    }

    // loop data to get count here
    for(var i=0; i<this.state.actualMapData[0]['values'].length; i++) {

      if(this.state.actualMapData[0]['values'][i]['key'] == title) {
        //console.log(this.state.actualMapData[0]['values'][i]['values'][0]['KreisSort'])
        if(this.state.actualMapData[0]['values'][i]['values'][0]['KreisSort'] == 'Kreis 1') {
          this.setState({
            tooltipCount: this.state.actualMapData[0]['values'][i]['values'][0]['QuadratmeterPreis'],
            tooltipKreis: this.state.actualMapData[0]['values'][i]['values'][0]['KreisSort'],
            tooltipCountAbsolute: this.state.actualMapData[0]['values'][i]['values'][0]['VeranderungProzent'],
            dataMatched: true
          })
        } else {  
          this.setState({
            tooltipCount: this.state.actualMapData[0]['values'][i]['values'][0]['QuadratmeterPreis'],
            tooltipKreis: '',
            tooltipCountAbsolute: this.state.actualMapData[0]['values'][i]['values'][0]['VeranderungProzent'],
            dataMatched: true
          })
        }
      }

      let svgElements = svg.getElementsByTagName('path');
      for(let c=0; c<svgElements.length; c++) {
        d3select(svgElements[c]).style('stroke', 'white');
        d3select(e).style('stroke-width', 1);
      }

      if(e.getAttribute('id') != 'see') {
        d3select(e).style('stroke', 'grey');
        d3select(e).style('stroke-width', 1.5);
        /* d3select(e).moveToFront('sali'); */
      }
    }


    // show tooltip here
    this.setState({
      showTooltip: true,
      tooltipX: e.getAttribute('cx'),
      tooltipTitle: title
    });

    //console.log(this.state.tooltipY)
  }

  mouseLeavesMapPart(e) {
    d3select(e).style('stroke', 'white');
    d3select(e).style('stroke-width', 1);
    // hide tooltip here
    this.setState({
      showTooltip: false,
      dataMatched: false
    })
  }

  render() {

    const data = this.props.dataSource;
    const locale = formatDefaultLocale(localeDefinition);

    // to keep 'this' alive in the data.map function below
    const _self = this;

    let margin = {top: 15, right: 20, bottom: 20, left: 35},
      w = this.state.width - (margin.left + margin.right),
      h = this.props.height - (margin.top + margin.bottom);

    const percentageFormat = locale.format('');

    data.forEach(function(d) {
      /* */
    })

    const transform = 'translate(' + margin.left + ',' + margin.top + ')';

    return (

        <div className={`ui ${this.props.readerMadeHisChoice ? '' : ''} segment padded`}>

          { this.props.mapTitle &&
            <h3
              style={{
                marginBottom: '0px',
                fontFamily: 'Benton Sans Cond',
                fontWeight: 'bold'
              }}            >
              {this.props.mapTitle}
            </h3>
          }
          { this.props.mapLead &&
            <p>{this.props.mapLead}</p>
          }

          <ReactSVG
            path={this.props.mapSource}
            className={this.props.mapClassName}
            callback={(svg) =>
            {

                console.log('callback');
                let svgElements = svg.getElementsByTagName('path');

                for(let c=0; c<svgElements.length; c++) {
                  if(svgElements[c].getAttribute('id') != 'see') {

                    // TODO loop data through and match with id

                    let title = svgElements[c].getAttribute('id');

                    // loop data to get count here
                    for(let i=0; i<this.state.actualMapData[0]['values'].length; i++) {
                      if(this.state.actualMapData[0]['values'][i]['key'] == title) {
                        let colorizeCount =  this.state.actualMapData[0]['values'][i]['values'][0]['QuadratmeterPreis'];
                        d3select(svgElements[c]).style('fill', this.colorScale(colorizeCount));
                      }
                    }



                    {/*d3select(svgElements[c]).style('opacity', 1);*/}
                  }
                }


                // DESKTOP AND TOUCH DEVICE SWITCH
                if (('ontouchstart' in window) ||
                  (navigator.maxTouchPoints > 0) ||
                  (navigator.msMaxTouchPoints > 0)) {

                  // Touch
                  for(var t=0; t<svgElements.length; t++) {
                    svgElements[t].addEventListener('touchstart', function(e) {
                      let element = e.currentTarget;
                      _self.mouseEntersMapPart(element, svg);
                    })
                  }

                } else {

                  // No Touch
                  for(var j=0; j<svgElements.length; j++) {
                    svgElements[j].addEventListener('mouseleave', function(e) {
                      e.preventDefault();
                      let element = e.currentTarget;
                      _self.mouseLeavesMapPart(element);
                      _self.setState({
                        showTooltip: false,
                        tooltipCount: '',
                        tooltipKreis: ''
                      })
                    })
                  }

                  for(var i=0; i<svgElements.length; i++) {
                    svgElements[i].addEventListener('mouseenter', function(e) {
                      let element = e.currentTarget;
                      _self.mouseEntersMapPart(element, svg);
                    })
                  }

                }






              }

            }

          />

          { this.state.showTooltip == true && this.state.dataMatched == true && this.state.tooltipKreis ?

            <p
              style={{
                position: 'absolute',
                top: this.state.tooltipY,
                textAlign: 'center',
                display: 'block',
                width: '100%',
                left: '0px',
                color: '#5A686D',
                fontSize: this.state.tooltipFontSize
              }}
            >
              {this.state.tooltipKreis}:&nbsp;
              <strong
                style={{borderBottom: '2px solid #5A686D'}}
              >
              {this.state.tooltipCount} Sfr.


              </strong>
            </p>

          : this.state.showTooltip == true && this.state.dataMatched == true &&

            <p
                style={{
                  position: 'absolute',
                  top: this.state.tooltipY,
                  textAlign: 'center',
                  display: 'block',
                  width: '100%',
                  left: '0px',
                  color: '#5A686D',
                  fontSize: this.state.tooltipFontSize
                }}
              >
                {this.state.tooltipTitle}:&nbsp;
                <strong
                  style={{borderBottom: '2px solid #5A686D'}}
                >
                {this.state.tooltipCount} Sfr.


                </strong>
              </p>

          }


          <p
            className='graphic legend'
          >Medianwerte für die Jahre 2014-2017<br/>
          Quelle: <a href='https://www.stadt-zuerich.ch/prd/de/index/statistik/ueber-uns/organisation/analysen.html' target='_blank'>Statistik Stadt Zürich</a></p>
        </div>


   );
  }

}

SVGMap.propTypes = {
  width: React.PropTypes.number,
  height: React.PropTypes.number,
  dataSource: React.PropTypes.array,
  mapSource: React.PropTypes.string,
  mapTitle: React.PropTypes.string,
  mapLead: React.PropTypes.string,
  mapClassName: React.PropTypes.string,
  mapId: React.PropTypes.string,
  readerMadeHisChoice: React.PropTypes.bool,
  tooltipWidth: React.PropTypes.number,
  tooltipHeight: React.PropTypes.number,
  tooltipFontSize: React.PropTypes.number,
  mapData: React.PropTypes.array,
  mapDataYear: React.PropTypes.number
}

export default SVGMap;


// WEBPACK FOOTER //
// ./src/components/svgQuarterMap/SVGMap.component.js